<template>
  <footer class="footer-wrap">
    <div class="footer">
      <div class="footer-t">
        <div class="logo">
          <img src="static/images/logo.png" alt="" />
          <div class="logo-r">
            <div class="txt1">{{ name }}</div>
            <div class="txt2">培训中心</div>
          </div>
        </div>
      </div>
      <div class="footer-b">
        <p>Copyright ©2024 天津瀚海星云数字科技股份有限公司</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { name: '网站链接', url: '' },
        { name: '网站链接', url: '' },
        { name: '网站链接', url: '' },
        { name: '网站链接', url: '' },
        { name: '网站链接', url: '' },
      ],
      name: window.SYS_CONFIG.FOOTER_NAME,
    }
  },
  mounted() {

  },
  methods: {
    handleLink(item) {
      if (item.url) {
        window.open(item.url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-wrap {
  width: 100%;
  background: url("~@/assets/images/home/footer-bg.png") no-repeat;
  background-size: 100% 100%;
  .footer {
    width: 1200px;
    margin: 0 auto;
    .footer-t {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 125px;
      .logo {
        display: flex;
        align-items: center;
        > img {
          width: 85px;
        }
        .logo-r {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 20px;
          .txt1 {
            font-size: 16px;
            line-height: 24px;
          }
          .txt2 {
            font-size: 28px;
            line-height: 30px;
            font-family: ReeJi-BigRuixain;
          }
        }
      }
      .linklist {
        margin-left: 52px;
        display: flex;
        > li {
          margin: 0 24px;
          &:hover {
            color: $--color-primary;
          }
        }
      }
    }
    .footer-b {
      height: 70px;
      border-top: 1px solid #dee1ed;
      display: flex;
      justify-content: center;
      align-items: center;
      > p {
        font-weight: 700;
        font-size: 16px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Footer.vue